export enum UpdatePeopleByListDialogMessages {
  MODAL_TITLE = 'Import People',
  IMPORT_LABEL = 'Import',
  UPLOAD_PROGRESS_TITLE = 'Upload Progress',
  UPLOAD_SUMMARY_TITLE = 'Upload Summary',
  FILE_PARSE_ERROR_MSG = 'There was an error processing your file: ',
  ARCHIVE_REVIEW_LABEL = 'Review users to be archived',
  ARCHIVE_USERS_LABEL = 'Archive Users',
}
